var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAudioCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#A9CF3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6665 18.78V20.78C21.6672 20.9657 21.6292 21.1494 21.5548 21.3195C21.4804 21.4897 21.3713 21.6424 21.2345 21.7679C21.0977 21.8934 20.9362 21.989 20.7603 22.0485C20.5844 22.1079 20.398 22.13 20.2131 22.1133C18.1617 21.8904 16.1911 21.1894 14.4598 20.0667C12.849 19.0431 11.4834 17.6774 10.4598 16.0667C9.33311 14.3275 8.63195 12.3473 8.41313 10.2866C8.39647 10.1023 8.41838 9.91649 8.47746 9.74107C8.53654 9.56564 8.63151 9.40444 8.7563 9.26773C8.8811 9.13102 9.033 9.02179 9.20232 8.947C9.37164 8.87221 9.55469 8.83349 9.73979 8.83332H11.7398C12.0633 8.83013 12.377 8.9447 12.6223 9.15567C12.8676 9.36664 13.0278 9.65961 13.0731 9.97998C13.1575 10.62 13.3141 11.2485 13.5398 11.8533C13.6295 12.0919 13.6489 12.3513 13.5957 12.6006C13.5426 12.8499 13.419 13.0787 13.2398 13.26L12.3931 14.1066C13.3422 15.7757 14.7241 17.1576 16.3931 18.1067L17.2398 17.26C17.4211 17.0807 17.6499 16.9572 17.8992 16.904C18.1485 16.8509 18.4078 16.8703 18.6465 16.96C19.2513 17.1857 19.8797 17.3422 20.5198 17.4267C20.8436 17.4723 21.1394 17.6355 21.3508 17.885C21.5622 18.1345 21.6746 18.453 21.6665 18.78Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAudioCall);
export default __webpack_public_path__ + "static/media/ico_audio_call.cddae53f9012526cc8264a1d6e69ae85.svg";
export { ForwardRef as ReactComponent };